import React from 'react';

interface Props {
    label: string;
    value: string;
    valueClassName?: string;
    /** Optional delta line rendered under the value. */
    delta?: React.ReactNode;
    /** Tighter typography for narrow tiles (account cards). */
    compact?: boolean;
}

/**
 * Stat tile for the landing cards/strips. The label zone has a fixed two-line
 * height so values across a row always sit on the same baseline, and the delta
 * wraps inside its own column instead of pushing into neighbouring tiles.
 */
const MetricStat: React.FC<Props> = ({ label, value, valueClassName, delta, compact }) => (
    <div className="min-w-0">
        <div className={`text-gray-500 leading-4 min-h-8 ${compact ? 'text-[11px]' : 'text-xs'}`}>
            {label}
        </div>
        <div
            className={`font-semibold tabular-nums whitespace-nowrap text-gray-900 ${compact ? 'text-base' : 'text-lg'} ${valueClassName || ''}`}
        >
            {value}
        </div>
        {delta && <div className="mt-0.5">{delta}</div>}
    </div>
);

export default MetricStat;
